import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, NODE_COLORS } from "../services/api";
import GraphView from "../components/GraphView";

export default function ContextGraph() {
  const [graph, setGraph] = useState(null);
  const [focus, setFocus] = useState("");
  const [path, setPath] = useState([]);
  const [params] = useSearchParams();

  useEffect(() => {
    const f = params.get("focus");
    if (f) {
      setFocus(f);
      api.graph(f).then(setGraph);
      // if focus is a dealer from an insight, fetch that insight's reasoning path
    } else {
      api.graph().then(setGraph);
    }
  }, [params]);

  const refocus = (id) => { setFocus(id); setPath([]); api.graph(id).then(setGraph); };
  const reset = () => { setFocus(""); setPath([]); api.graph().then(setGraph); };

  return (
    <div className="graph-page">
      <div className="graph-toolbar">
        <div className="graph-legend">
          {Object.entries(NODE_COLORS).map(([t, c]) => (
            <span key={t} className="gl-item"><i style={{ background: c }} />{t}</span>
          ))}
        </div>
        <div className="graph-tb-actions">
          {focus && <span className="focus-chip">Focused: {focus}</span>}
          {focus && <button className="btn-ghost sm" onClick={reset}>Show full graph</button>}
        </div>
      </div>
      <div className="graph-canvas-wrap">
        {graph ? (
          <GraphView nodes={graph.nodes} edges={graph.edges} highlight={path} onNodeClick={refocus} />
        ) : (
          <div className="loading-page">Building context graph…</div>
        )}
      </div>
      <div className="graph-hint">Click any node to traverse its 2-hop neighbourhood. Nodes model Kajaria entities; edges are the enterprise relationships DotIQ traverses.</div>
    </div>
  );
}
